<template>
  <div class="ukey">
    <div class="tabbar"><span class="iconfont" @click="handleGo()">{{'\ue682'}}</span></div>
    <div class="tips">
      <div>
        <div class="icon iconfont">
          {{'\ue6e2'}}
        </div>
        <div>
          <div>Ukey新税盘需修改初始密码后才能登录</div>
          <div>使用初始密码为88888888</div>
        </div>
      </div>
    </div>
    <div class="ukey-box">
    <header>设置税控密码</header>
    <div class="ukey-box-model">
      <img src="../../../../src/assets/img/ukeyBox.png" class="ukey-img" />
    </div>
    <div class="ukey-box-message">
      <div class="ukey-name">
        <span>型号</span><span>{{ 'Ukey盒子' }}</span>
      </div>
      <div class="ukey-code">
        <span>设备SN</span><span>{{ formData.boxCode }}</span>
      </div>
    </div>
    <div :class="['set-ukey',colorShow ?  'color' : '']">
      <van-field
        v-model="formData.devicePwd"
        type="password"
        label="税控Ukey密码"
        placeholder="请输入税控Ukey密码"
      />
      <i v-if="formData.devicePwd !== '' " class="huisuiyunfont ok">{{'\ue614'}}</i>
    </div>
    <div :class="['set-ukey',colorShow ?  'color' : '']">
      <van-field
        v-model="formData.certPwd"
        type="password"
        class="field"
        label="证书密码"
        placeholder="请输入证书密码"
      />
      <i v-if="formData.certPwd !== '' " class="huisuiyunfont ok">{{'\ue614'}}</i>
    </div>
    <div :class="['next-step', showButton ? '' : 'disabled-button']" @click="showButton ? handleClick() : handleClick('woring') ">
      提交
    </div>
  </div>
  </div>
</template>
<script>
import { getQuery } from '@/utils/basicUtil'
import { ukeyBoxRequest } from '@services'
import { Field, Notify } from 'vant'
export default {
  data () {
    return {
      phone: '',
      formData: {
        devicePwd: '',
        certPwd: '',
        boxCode: '',
        action: '1',
        deviceNo: '',
        deviceType: '',
        taxNo: ''
      }
    }
  },
  async created () {
    let { action } = getQuery()
    if (action) {
      this.formData.action = action
    }
    if (sessionStorage.ukeyBox) {
      let ukeyBox = JSON.parse(sessionStorage.ukeyBox)
      this.formData.boxCode = ukeyBox.boxCode
      this.phone = ukeyBox.phone
      let data = await ukeyBoxRequest.ukeyBox.getBoxInfo({ boxCode: ukeyBox.boxCode })
      if (data.success) {
        this.formData.deviceNo = data.result.deviceNo
        this.formData.deviceType = data.result.deviceType
        this.formData.taxNo = data.result.taxNo
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  },
  methods: {
    async handleClick (woring) {
      if (woring) {
        Notify({ type: 'danger', message: '请完善盘密码和证书密码！' })
      }
      let data = await ukeyBoxRequest.ukeyBox.setBoxBind({ ...this.formData })
      console.log(data)
      if (data.success) {
        sessionStorage.newCompanyId = data.result
        Notify({ type: 'success', message: '绑定成功' })
        setTimeout(() => {
          this.$router.push('/')
        }, 2000)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    handleGo () {
      this.$router.go(-1)
    },
    onInputChange ({ e, field }) {
      this.formData[field] = e
    }
  },
  computed: {
    showButton () {
      if (this.formData.devicePwd !== '' && this.formData.certPwd !== '') {
        return true
      } else {
        return false
      }
    },
    colorShow () {
      if (this.formData.devicePwd !== '' || this.formData.certPwd !== '') {
        return true
      } else {
        return false
      }
    },
    getPassword () {
      if (this.formData.devicePwd === '' || this.formData.certPwd === '') {
        return '2'
      }
      return this.formData.certPwd === '123' ? '1' : ''
    }
  },
  components: {
    [Field.name]: Field
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
